<mat-sidenav-container [ngClass]="{'cardBorder': options.cardBorder, }" [dir]="options.dir!">
  <div class="blank-layout-container justify-content-center">
    <div class="position-relative row w-100 h-100">
      <div class="col-lg-4 col-xl-4 col-md-5 col-xs-12 col-sm-12">
        <div class="col d-flex justify-content-center align-items-center h-100">
          <div class="col-12 max-width-form">
            <app-messages></app-messages>
            <a [routerLink]="['/dashboard']">
              <img src="/assets/images/logos/logo_green.png" class="align-middle m-2 logo" alt="logo"/>
            </a>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
      <div
        class="col-lg-8 col-xl-8 col-md-7 col-xs-12 col-sm-12 position-relative overflow-hidden bg-dark-200 d-none d-lg-block d-xl-block d-md-block bg-layout">
        <div class="blurred-bg"></div>
        <div>
          <!--<img src="/assets/images/logos/logo_square.svg" class="circle-bottom" alt="Logo-Dark"/>-->
        </div>
        <div class="d-flex align-items-center z-1 position-relative h-n80">
          <div class="row justify-content-center w-100">
            <div class="col-lg-6">
              <h2 class="text-white f-s-40 m-b-16 lh-base text-center">
                {{ "login.welcome_to_xrsupport" | translate }}
              </h2>
              <span class="op-75 f-s-16 text-white d-block m-b-16">
                {{ "login.slogan" | translate }}
            </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</mat-sidenav-container>